import { useRef, useState, type PointerEvent } from 'react';
import { itemIconPath } from '../../compositor/assetPaths';
import { clampToBand, clientToStagePct, type Point } from '../wanderMath';
import type { PlayletProps } from './types';

const WIN_CATCHES = 3;

export function FetchPlaylet({ goTo, onWin, onQuit }: PlayletProps) {
  const [toy, setToy] = useState<Point | null>(null);
  const [caught, setCaught] = useState(0);
  const busyRef = useRef(false);
  const catchesRef = useRef(0);
  const wonRef = useRef(false);
  const quitRef = useRef(false);

  async function handlePointerUp(e: PointerEvent<HTMLDivElement>) {
    if (busyRef.current || wonRef.current || quitRef.current) return;
    if ((e.target as Element).closest('.habitat-playlet-quit, .habitat-playlet-progress')) return;
    const scene = e.currentTarget.closest('.habitat-scene') ?? e.currentTarget;
    const drop = clampToBand(clientToStagePct(e.clientX, e.clientY, scene.getBoundingClientRect()));
    setToy(drop);
    busyRef.current = true;
    try {
      await goTo(drop, { forceRun: true });
      if (quitRef.current) return;
      catchesRef.current += 1;
      setCaught(catchesRef.current);
      if (catchesRef.current >= WIN_CATCHES) {
        wonRef.current = true;
        onWin();
      }
    } finally {
      busyRef.current = false;
    }
  }

  function handleQuit() {
    quitRef.current = true;
    onQuit();
  }

  return (
    <div className="habitat-playlet" onPointerUp={handlePointerUp}>
      <p className="form-note habitat-playlet-hint">Tap the floor to throw the toy</p>
      <span className="chip habitat-playlet-progress">{caught}/{WIN_CATCHES}</span>
      <button
        type="button"
        className="chip habitat-playlet-quit"
        onPointerUp={(e) => e.stopPropagation()}
        onClick={handleQuit}
      >
        Quit
      </button>
      {toy && (
        <img
          className="habitat-playlet-toy"
          src={itemIconPath('feather_wand')}
          alt=""
          style={{ left: `${toy.x}%`, top: `${toy.y}%` }}
        />
      )}
    </div>
  );
}
